export const MESSAGES = {
 OTP_SENT: "OTP sent successfully",
 OTP_VERIFIED: "OTP verified successfully",
 SIGNUP_SUCCESS: "Signup completed successfully",
 LOGIN_SUCCESS: "Login successful",

 ACCOUNT_LINK_REQUIRED:"Account exists. Please confirm linking via OTP",
 JOIN_TEXT:"Join",
 SPEAK_BOLD_WITH_KK_TEXT:"SpeakBold with KK",
 START_IMPROVING:"and start improving today",

 USER_SUSPENDED: "Your account has been suspended. Please contact support.",
 EMAIL_ALREADY_REGISTERED: "This email is already registered. Please login or use another email.",
 EMAIL_REGISTERED_VIA_GOOGLE: "This email is registered via Google. Please login using Google Sign-in.",
 OTP_EXPIRED: "The entered OTP has expired. Please request a new OTP.",
 OTP_INVALID: "The entered OTP is invalid. Please check and try again.",
 OTP_USED: "This OTP has already been used.",
 SIGN_UP_SESSION_EXPIRED: "Signup session expired. Please try again.",
 USER_NOT_FOUND: "User not found.",
 FILL_ALL_FIELDS: "Fill all the fields",
};
